// extracted by mini-css-extract-plugin
export default {"headerFoot":"HeaderFoot_headerFoot__Oyfho","text":"HeaderFoot_text__HjEUF"};